class OurStorySection {
  constructor(selector, options) {
    this.splide = new Splide(selector, options);
    this.paginationInfoContainer = document.querySelector('.don-hero-slideshow .js-pagination-info');

    this.updatePageInfo = this.updatePageInfo.bind(this);
  }

  init() {
    this.splide.mount();
    this.splide.on('moved', this.updatePageInfo);
    this.updatePageInfo();
  }

  updatePageInfo() {
    const totalItems = this.splide.length;
    const itemsPerPage = this.splide.options.perPage;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const currentPage = Math.ceil((this.splide.index + 1) / itemsPerPage);
    this.paginationInfoContainer.textContent = `${currentPage} / ${totalPages}`;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const slides = document.querySelectorAll('.don-hero-slideshow--slider .splide__slide').length;
  
    const splideOurStorySection = new OurStorySection('.don-hero-slideshow--slider', {
      type: 'slide',
      perPage: 1,
      rewind: true,
      pagination: slides > 1,
      arrows: slides > 1,
      autoWidth: true,
      focus    : 0,
      omitEnd  : true,
      gap: '18px',
      breakpoints: {
        768: {
          perPage: 1,
        },
      }
    });

    splideOurStorySection.init();

});
